export default __webpack_public_path__ + "static/media/iiitk_logo.170d5585.png";